
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL = "https://api.gigagates.com/ezy-express-backend";//"http://localhost:8080/qq-delivery-backend";//
}

export default Resources;